$( () => {

    if ( $('.swiper-testimonial').length > 0 ) {
        var swiperTestimonial = new Swiper(".swiper-testimonial", {
            slidesPerView: 1,
            spaceBetween: 15,
            roundLengths: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
                navigation: {
                    nextEl: '.swiper-testimonial-next',
                    prevEl: '.swiper-testimonial-prev',
                },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                992: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
            },
        });
    }
    const swiperThumbs = new Swiper('.swiper-thumbs', {
    direction: 'vertical',
    loop: true,
    slidesPerView: 2,
    spaceBetween: 18,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    });
      

    if ( $('.swiper-review').length > 0 ) {
        var swiperReview = new Swiper(".swiper-review", {
            slidesPerView: 1,
            spaceBetween: 15,
            roundLengths: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-review-next',
                prevEl: '.swiper-review-prev',
            },
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
            },
        });
    }

    if ( $('.swiper-products').length > 0 ) {
        var swiperProducts = new Swiper(".swiper-products", {
            slidesPerView: 1,
            spaceBetween: 15,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
                navigation: {
                    nextEl: '.swiper-products-next',
                    prevEl: '.swiper-products-prev',
                },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                },
            },
        });
    }

    if ( $('.swiper-offers').length > 0 ) {
        var swiperOffers = new Swiper(".swiper-offers", {
            slidesPerView: 1,
            spaceBetween: 15,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
                navigation: {
                    nextEl: '.swiper-offers-next',
                    prevEl: '.swiper-offers-prev',
                },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
            },
        });
    }

    if ( $('.swiper-small').length > 0 ) {
        var swiperSmall = new Swiper(".swiper-small", {
            slidesPerView: 1,
            spaceBetween: 15,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
                navigation: {
                    nextEl: '.swiper-small-next',
                    prevEl: '.swiper-small-prev',
                },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
            },
        });
    }

    if ( $('.swiper-blog').length > 0 ) {
        let activeCategory = $('.swiper-blog').attr('data-active');
        console.log(activeCategory);
        var swiperBlog = new Swiper(".swiper-blog", {
            slidesPerView: 'auto',
            spaceBetween: 0,
            // centered: true,
            centerInsufficientSlides: true,
            centeredSlidesBounds: true,
            initialSlide : activeCategory,
            navigation: {
                nextEl: '.swiper-blog-next',
                prevEl: '.swiper-blog-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                },
                992: {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                },
            },
        });
    }

    if ( $('.swiper-featured').length > 0 ) {
        var swiperFeatured = new Swiper(".swiper-featured", {
            slidesPerView: 1,
            spaceBetween: 15,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            // navigation: {
            //     nextEl: '.swiper-small-next',
            //     prevEl: '.swiper-small-prev',
            // },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
            },
        });
    }

    if ( $('.swiper-package').length > 0 ) {
        const sizeClasses = ['bullet-s','bullet-l', 'bullet-xl'];
        var swiperPackage = new Swiper(".swiper-package", {
            slidesPerView: 1,
            spaceBetween: 15,
            pagination: {
                el: ".pagination-package",
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className} ${sizeClasses[index]}">${$('#gift-box-slide-' + index).data('badge')}</span>`;
                },
            },
            // navigation: {
            //     nextEl: '.swiper-small-next',
            //     prevEl: '.swiper-small-prev',
            // },
        });
    }

    
    // var swiperBanner = new Swiper(".swiper-banner", {
    //     slidesPerView: 'auto',
    //     // slidesPerView: 3,
    //     centeredSlides: true,
    //     autoHeight: true,
    //     // loop: true,
    //     spaceBetween: 10,
    //     navigation: {
    //         nextEl: '.swiper-banner-next',
    //         prevEl: '.swiper-banner-prev',
    //     },
    //     autoplay: {
    //         delay: 5000,
    //         disableOnInteraction: false,
    //     },
    // });

    // var swiperGallery = new Swiper(".swiper-gallery", {
    //     slidesPerView: 1,
    //     spaceBetween: 10,
    //     freeMode: true,
    //     loop: true,
    //     navigation: {
    //         nextEl: ".gallery-next",
    //         prevEl: ".gallery-prev",
    //     },
    //     autoplay: {
    //         delay: 2500,
    //         disableOnInteraction: false,
    //     },
    //     breakpoints: {
    //         576: {
    //             slidesPerView: 'auto',
    //             spaceBetween: 20,
    //         },
    //         992: {
    //             slidesPerView: 'auto',
    //             spaceBetween: 15,
    //         },
    //         1200: {
    //             slidesPerView: 'auto',
    //             spaceBetween: 10,
    //         },
    //     },
    // });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/slider.js